import React, { useContext, useState, useEffect } from "react";
import axiosInstance from "../../../services/AxiosInstance";
import Api from "../../../constants/Api";
import { ApiError } from "../../components/Common/ApiError";
import { useTranslation } from "react-i18next";
import HeaderProfile from "./HeaderProfile";
import HeaderNotifications from "./HeaderNotifications";
import HeaderQuickLinks from "./HeaderQuickLinks";
import { Dropdown } from "react-bootstrap";
import { useBranch } from "../../../context/BranchContext";
import { useLocation } from "react-router-dom";
import { ThemeContext } from "../../../context/ThemeContext";
import "./Header.css";

const LocationIcon = <i className="fa-solid fa-location-dot mx-2 " />;

function AddSearchSlider() {
	let SearchBlog = document.getElementById("Search-Blog");
	let BoxTab = document.getElementById("close-searchbox");

	setTimeout(() => {
		if (BoxTab.classList.contains("active")) {
			return BoxTab.classList.remove("active"), SearchBlog.classList.remove("active");
		} else {
			return BoxTab.classList.add("active"), SearchBlog.classList.add("active");
		}
	}, 100);
}

const Header = () => {

	const { t } = useTranslation();
	const location = useLocation(); // Obtém a rota atual
	const { appTheme, toggleAppTheme } = useContext(ThemeContext);

	//const [rightSelect, setRightSelect] = useState('Eng');

	// Permite armazenar a filial selecionada em qualquer tela.
	const { selectedBranch, setSelectedBranch, branches, setBranches } = useBranch();

	// For fix header
	const [headerFix, setheaderFix] = useState(false);
	
	const [trialInfo, setTrialInfo] = useState(null);

	// Mesma resposta usada pelo trial, guardada com o nome do que ela é de fato:
	// dela saem o uuid e o publicSlug que montam os links públicos do cabeçalho.
	const [companyInfo, setCompanyInfo] = useState(null);

	// Busca os dados da api
	useEffect(() => {
		axiosInstance.get(Api.main.branch + "/user")
			.then((resp) => {
				setBranches(resp.data);

				if (resp.data.length === 1) {
					// Seleciona o primeiro.
					setSelectedBranch(resp.data[0]);
				} else {
					setSelectedBranch(null);
				}
			})
			.catch(error => ApiError(error));
			
		axiosInstance.get(Api.registration.company_info)
			.then((resp) => {
				setTrialInfo(resp.data);
				setCompanyInfo(resp.data);
			})
			.catch(error => {
				// Silently ignore or log if there is no company info
				console.error(error);
			});
	}, []);

	useEffect(() => {
		setTimeout(function () {
			// Dropdown 
			const dropbtn = document.getElementById("droptoggle1")
			if (!dropbtn) return;
			//let dropTooglebtn = dropbtn.getAttribute("aria-expanded");
			function toggledrop() {
				return dropbtn.classList.toggle("show")
			}
			dropbtn.addEventListener("click", toggledrop);
		}, 500);

		// for header fix on scroll
		window.addEventListener("scroll", () => {
			setheaderFix(window.scrollY > 50);
		});
	}, []);

	const branchOptions = (
		<>
			<Dropdown.Item onClick={() => setSelectedBranch(null)}>{LocationIcon} {t('all_branches')}</Dropdown.Item>
			{branches?.map((branch) => (
				<Dropdown.Item key={branch.id} onClick={() => setSelectedBranch(branch)}>
					{LocationIcon} {branch.name}
				</Dropdown.Item>
			))}
		</>
	);

	return (
		<>
			<div className={`header ${headerFix ? "is-fixed" : ""}`}>
				<div className="header-content">
					<nav className="navbar navbar-expand">
						<div className="container d-block my-0">
							<div className="d-flex align-items-center justify-content-sm-between justify-content-end">
								<div className="header-left">
									<div className="nav-item d-flex align-items-center">
										<div className="d-flex header-bx align-items-center" id="Search-Blog" style={{marginLeft: '20px'}}>
											{/** Dropdown com as filiais */}
											<Dropdown className="bootstrap-select d-none d-md-block">
												<Dropdown.Toggle className="header-select-toggle btn btn-light i-false" as="div">
													{selectedBranch ? <>{LocationIcon} {selectedBranch.name}</> : t('all_branches')}
													<i className="header-select-icon fa-solid fa-sort-down" style={{ marginTop: '-5px' }}></i>
												</Dropdown.Toggle>
												<Dropdown.Menu>
													{branchOptions}
												</Dropdown.Menu>
											</Dropdown>
											
											{trialInfo && trialInfo.trialDays > 0 && (
												<div className="ms-3 d-none d-sm-block">
													{trialInfo.isTrialExpired ? (
														<span className="badge badge-danger" style={{ fontSize: '13px' }}>{t('trial_version_expired')}</span>
													) : (
														<span className="badge badge-warning text-white" style={{ fontSize: '13px' }}>
															{t('trial_version_remaining', { days: trialInfo.trialDaysRemaining })}
														</span>
													)}
												</div>
											)}
										</div>
									</div>
								</div>
								<ul className="navbar-nav header-right">
									<li className="d-md-none align-self-center me-2">
										<Dropdown className="mobile-branch-select">
											<Dropdown.Toggle
												className="mobile-branch-select__toggle"
												aria-label={selectedBranch
													? `${t('branch')}: ${selectedBranch.name}`
													: t('all_branches')}
												title={selectedBranch?.name || t('all_branches')}
											>
												<i className="fa-solid fa-location-dot" aria-hidden="true" />
												{selectedBranch && (
													<i
														className="fa-solid fa-check mobile-branch-select__indicator"
														aria-hidden="true"
													/>
												)}
											</Dropdown.Toggle>
											<Dropdown.Menu align="end" className="mobile-branch-select__menu">
												{branchOptions}
											</Dropdown.Menu>
										</Dropdown>
									</li>
									{trialInfo && trialInfo.trialDays > 0 && (
										<li className="d-sm-none align-self-center me-2">
											{trialInfo.isTrialExpired ? (
												<span className="badge badge-danger">{t('expired')}</span>
											) : (
												<span className="badge badge-warning text-white">{t('trial_version_remaining_mobile', { days: trialInfo.trialDaysRemaining })}</span>
											)}
										</li>
									)}
									{/* Links públicos (agendamento e portal do colaborador) sempre à mão, em
									    qualquer tela — antes ficavam escondidos dentro de telas específicas. */}
									<li className="align-self-center me-2">
										<HeaderQuickLinks companyInfo={companyInfo} />
									</li>
									<li className="align-self-center me-2">
										<button
											type="button"
											className="colmeia-theme-toggle"
											onClick={toggleAppTheme}
											aria-label={appTheme === 'dark' ? 'Ativar tema claro' : 'Ativar tema escuro'}
											title={appTheme === 'dark' ? 'Ativar tema claro' : 'Ativar tema escuro'}
											aria-pressed={appTheme === 'light'}
										>
											<i className={`fa-solid ${appTheme === 'dark' ? 'fa-sun' : 'fa-moon'}`} aria-hidden="true" />
										</button>
									</li>
									<li>
										<HeaderNotifications />
									</li>
									<li>
										<HeaderProfile />
									</li>
								</ul>
							</div>
						</div>
					</nav>
				</div>
			</div>
		</>
	);
};

export default Header;
